import script from "./CompetitionFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionFilter.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionFilter.vue?vue&type=style&index=0&id=3f1f7928&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1f7928"]])

export default __exports__